(() => {
  const q = (s, c = document) => c.querySelector(s);
  const qa = (s, c = document) => [...c.querySelectorAll(s)];

  const toast = (message) => {
    const el = q('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(window.__mateToast);
    window.__mateToast = setTimeout(() => el.classList.remove('is-visible'), 2600);
  };

  const updateCount = (count) => qa('[data-cart-count]').forEach(el => {
    el.textContent = count;
    el.hidden = count < 1;
  });

  const openDrawer = () => {
    const drawer = q('#CartDrawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    setTimeout(() => q('[data-cart-close]', drawer)?.focus(), 50);
  };

  const closeDrawer = () => {
    const drawer = q('#CartDrawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  };

  const replaceDrawer = (html) => {
    if (!html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incoming = doc.querySelector('#CartDrawer');
    const current = q('#CartDrawer');
    if (!incoming || !current) return false;
    const countText = incoming.getAttribute('data-cart-item-count');
    if (countText === null || !/^\d+$/.test(countText)) return false;
    current.replaceWith(incoming);
    updateCount(Number(countText));
    return true;
  };

  const refreshCart = async (open = false) => {
    try {
      const [cartRes, sectionRes] = await Promise.all([
        fetch(`${window.Mateadicto.root}cart.js`, { headers: { Accept: 'application/json' } }),
        fetch(`${window.Mateadicto.root}?section_id=cart-drawer`)
      ]);
      if (!cartRes.ok || !sectionRes.ok) throw new Error('No se pudo actualizar el carrito');
      const cart = await cartRes.json();
      const html = await sectionRes.text();
      replaceDrawer(html);
      updateCount(cart.item_count);
      if (open) openDrawer();
    } catch (e) { console.error(e); }
  };
  const syncQuantityLimit = (form) => {
    const scope = form.closest('[data-product-scope]');
    const limitsElement = scope?.querySelector('[data-quantity-limits]');
    const quantity = form.querySelector('[name="quantity"]');
    const variant = form.querySelector('[name="id"]');

    if (!limitsElement || !quantity || !variant) return;

    const limits = JSON.parse(limitsElement.textContent);
    const limit = limits[variant.value];

    quantity.step = '1';
    quantity.setCustomValidity('');

    if (typeof limit !== 'number') {
      quantity.removeAttribute('max');
      return;
    }

    quantity.max = String(limit);

    if (limit === 0) {
      quantity.setCustomValidity('Esta variante está agotada.');
    } else if (Number(quantity.value) > limit) {
      quantity.value = String(limit);
      toast(`Disponible: hasta ${limit} unidades de esta opción.`);
    }
  };

  const initializeQuantityLimits = () => {
    qa('[data-product-scope] form.ajax-cart-form')
      .forEach(syncQuantityLimit);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeQuantityLimits);
  } else {
    initializeQuantityLimits();
  }

  document.addEventListener('shopify:section:load', initializeQuantityLimits);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-variant-select], [name="quantity"]')) return;
    const form = event.target.closest('form.ajax-cart-form');
    if (form) syncQuantityLimit(form);
  });
  const addFormUnchecked = async (form) => {
        syncQuantityLimit(form);
    if (!form.reportValidity()) return;
    const submit = q('[type="submit"]', form);
    const original = submit?.textContent;
    if (submit) { submit.disabled = true; submit.textContent = 'Agregando…'; }
    try {
      const data = new FormData(form);
      data.append('sections', 'cart-drawer');
      data.append('sections_url', window.location.pathname);
      const response = await fetch(window.Mateadicto.cartAdd, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const json = await response.json();
      if (!response.ok) throw new Error(json.description || json.message || 'No se pudo agregar el producto');
      if (replaceDrawer(json.sections?.['cart-drawer'])) {
        openDrawer();
      } else {
        await refreshCart(true);
      }
      toast('Producto agregado al carrito');
    } catch (e) {
      toast(e.message || 'Ocurrió un error');
    } finally {
      if (submit) { submit.disabled = false; submit.textContent = original; }
    }
  };

  const changeLineUnchecked = async (line, quantity) => {
    try {
      const response = await fetch(window.Mateadicto.cartChange, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'No se pudo actualizar el carrito');
      if (replaceDrawer(cart.sections?.['cart-drawer'])) {
        updateCount(cart.item_count);
        openDrawer();
      } else {
        await refreshCart(true);
      }
    } catch (e) { toast(e.message || 'No se pudo actualizar el carrito'); }
  };
    // Evita operaciones simultáneas y valida el total por variante.
  let cartOperationBusy = false;

  const readStockState = async () => {
    const root = window.Mateadicto.root;

    const [cartResponse, drawerResponse] = await Promise.all([
      fetch(`${root}cart.js`, {
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }),
      fetch(`${root}?section_id=cart-drawer`, {
        cache: 'no-store'
      })
    ]);

    if (!cartResponse.ok || !drawerResponse.ok) {
      throw new Error('No se pudo comprobar el stock. Intentá nuevamente.');
    }

    const cart = await cartResponse.json();
    const html = await drawerResponse.text();
    const documentCopy = new DOMParser().parseFromString(html, 'text/html');
    const limits = new Map();

    if (!documentCopy.querySelector('#CartDrawer')) {
      throw new Error('No se pudo comprobar el carrito. Recargá la página.');
    }

    documentCopy.querySelectorAll('[data-stock-variant]').forEach((item) => {
      const id = item.dataset.stockVariant;
      const limit = item.hasAttribute('data-stock-limit')
        ? Number(item.dataset.stockLimit)
        : null;

      limits.set(id, limit);
    });

    return { cart, limits };
  };

  const runCartOperation = async (operation) => {
    if (cartOperationBusy) return;
    cartOperationBusy = true;

    try {
      await operation();
    } catch (error) {
      toast(error.message || 'No se pudo comprobar el stock.');
    } finally {
      cartOperationBusy = false;
    }
  };

  const addForm = async (form) => {
    await runCartOperation(async () => {
      syncQuantityLimit(form);
      if (!form.reportValidity()) return;

      const data = new FormData(form);
      const variantId = String(data.get('id'));
      const requested = Number(data.get('quantity') || 1);

      if (!Number.isInteger(requested) || requested < 1) {
        toast('Ingresá una cantidad válida.');
        return;
      }

      const scope = form.closest('[data-product-scope]');
      const limitsElement = scope?.querySelector('[data-quantity-limits]');

      if (!limitsElement) {
        throw new Error('Faltan los datos de stock. Recargá la página.');
      }

      const productLimits = JSON.parse(limitsElement.textContent);

      if (!Object.prototype.hasOwnProperty.call(productLimits, variantId)) {
        throw new Error('No se pudo comprobar esta variante. Recargá la página.');
      }

      const { cart, limits } = await readStockState();
      const stock = limits.has(variantId)
        ? limits.get(variantId)
        : productLimits[variantId];

      if (typeof stock === 'number') {
        const alreadyInCart = cart.items.reduce((total, item) => {
          return String(item.variant_id) === variantId
            ? total + item.quantity
            : total;
        }, 0);

        const remaining = Math.max(0, stock - alreadyInCart);

        if (requested > remaining) {
          toast(
            remaining === 0
              ? `Ya tenés el stock disponible en el carrito (${stock} unidades).`
              : `Ya tenés ${alreadyInCart} en el carrito. Podés agregar hasta ${remaining} más.`
          );
          return;
        }
      }

      await addFormUnchecked(form);
    });
  };

  const changeLine = async (line, quantity) => {
    await runCartOperation(async () => {
      if (!Number.isInteger(quantity) || quantity < 0) return;

      const { cart, limits } = await readStockState();
      const item = cart.items[line - 1];

      if (!item) {
        await refreshCart(true);
        return;
      }

      // Siempre permite eliminar o reducir una cantidad excesiva.
      if (quantity > item.quantity) {
        const variantId = String(item.variant_id);

        if (!limits.has(variantId)) {
          throw new Error('No se pudo comprobar el stock. Recargá la página.');
        }

        const stock = limits.get(variantId);

        if (typeof stock === 'number') {
          const otherQuantity = cart.items.reduce((total, other, index) => {
            return index !== line - 1 &&
              String(other.variant_id) === variantId
              ? total + other.quantity
              : total;
          }, 0);

          const maximum = Math.max(0, stock - otherQuantity);

          if (quantity > maximum) {
            toast(`Stock disponible: ${stock} unidades en total para esta variante.`);
            return;
          }
        }
      }

      await changeLineUnchecked(line, quantity);
    });
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form.ajax-cart-form');
    if (!form) return;
    if (event.submitter && event.submitter.closest && event.submitter.closest('.shopify-payment-button')) return;
    event.preventDefault();
    addForm(form);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); openDrawer(); }
    if (event.target.closest('[data-cart-close], [data-cart-overlay]')) { event.preventDefault(); closeDrawer(); }
    const qty = event.target.closest('[data-cart-qty]');
    if (qty) { event.preventDefault(); changeLine(Number(qty.dataset.line), Math.max(0, Number(qty.dataset.quantity))); }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); changeLine(Number(remove.dataset.line), 0); }

    const openSearch = event.target.closest('[data-search-open]');
    const closeSearch = event.target.closest('[data-search-close]');
    if (openSearch) { event.preventDefault(); q('#SearchOverlay')?.classList.add('is-open'); q('#SearchOverlay input[type=search]')?.focus(); }
    if (closeSearch || (event.target.id === 'SearchOverlay')) q('#SearchOverlay')?.classList.remove('is-open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { closeDrawer(); q('#SearchOverlay')?.classList.remove('is-open'); }
  });

  // Product variant selector
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;

    const option = select.options[select.selectedIndex];
    const scope = select.closest('[data-product-scope]') || document;
    const price = q('[data-product-price]', scope);
    const compare = q('[data-product-compare]', scope);
    const submit = q('[type=submit]', scope);

    if (price && option.dataset.price) {
      price.innerHTML = option.dataset.price;
    }

    if (compare) {
      compare.innerHTML = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }

    if (submit) {
      submit.disabled = option.dataset.available !== 'true';
    }

    const discountBadge = q('[data-variant-discount]', scope);
    if (discountBadge) {
      const discount = Number(option.dataset.discount || 0);
      const onSale = Boolean(option.dataset.compare);

      discountBadge.textContent = discount + '% OFF';
      discountBadge.hidden = !onSale;
      discountBadge.style.display = onSale ? '' : 'none';
    }
  });
  // Predictive search
  let searchController;
  const searchInput = q('[data-predictive-input]');
  if (searchInput) {
    searchInput.addEventListener('input', async () => {
      const term = searchInput.value.trim();
      const target = q('[data-predictive-results]');
      if (!target) return;
      if (term.length < 2) { target.innerHTML = ''; return; }
      searchController?.abort(); searchController = new AbortController();
      const url = `${window.Mateadicto.searchSuggest}?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`;
      try {
        const res = await fetch(url, { signal: searchController.signal });
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        target.innerHTML = doc.querySelector('#shopify-section-predictive-search')?.innerHTML || text;
      } catch (e) { if (e.name !== 'AbortError') console.error(e); }
    });
  }

  // Sticky transparent header
  const header = q('[data-site-header]');
  if (header) {
    let scrolled;
    const onScroll = () => {
      const next = window.scrollY > 20;
      if (next !== scrolled) { header.classList.toggle('is-scrolled', next); scrolled = next; }
    };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Reveal animations
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: .08 });
    qa('[data-reveal]').forEach(el => observer.observe(el));
  } else qa('[data-reveal]').forEach(el => el.classList.add('is-visible'));})();
// Cambio de imagen por variante
document.addEventListener('change', function(e) {
  var sel = e.target.closest('[data-variant-select]');
  if (!sel) return;
  var variantId = sel.value;
  var product = window.__productData;
  if (!product) return;
  var variant = product.variants.find(function(v){ return v.id == variantId; });
  if (!variant || !variant.featured_media) return;
  var mediaId = variant.featured_media.id;
  var item = document.getElementById('Media-' + mediaId);
  if (!item) return;
  item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
});
